import { render, staticRenderFns } from "./WithdrawList.vue?vue&type=template&id=2a53b10e&scoped=true"
import script from "./WithdrawList.vue?vue&type=script&lang=js"
export * from "./WithdrawList.vue?vue&type=script&lang=js"
import style0 from "./WithdrawList.vue?vue&type=style&index=0&id=2a53b10e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a53b10e",
  null
  
)

export default component.exports